import { userRoles, statuses } from '../../utils/constants'

export const isRoleSportsman = (roles) => {
  return roles?.includes(userRoles.ROLE_SPORTSMAN.value)
}

export const isRoleCoach = (roles) => {
  return roles?.includes(userRoles.ROLE_COACH.value)
}

export const isRoleOrganizer = (roles) => {
  return roles?.includes(userRoles.ROLE_ORGANIZER.value)
}

export const isRoleSportsmanOrCoach = (roles) => {
  return isRoleCoach(roles) || isRoleSportsman(roles)
}

export const isStatusPending = (status) => {
  return status === statuses.pending.value
}
